import { Question } from '../types';

// Person in Need of Care Questions
export const personCareQuestions: Question[] = [
  {
    questionKey: 'lastName',
    question: 'Wie ist der Familienname des pflegebedürftigen Antragstellers ?',
    type: 'text',
    required: true,
    answers: '',
  },
  {
    questionKey: 'name',
    question: 'Und wie ist der Vorname?',
    type: 'text',
    required: true,
    answers: '',
  },
  {
    questionKey: 'birthday',
    question: 'Dann brauche ich bitte das Geburtsdatum.',
    type: 'date',
    required: false,
    answers: '',
  },
  {
    questionKey: 'address',
    question: 'Danke! In welcher Strasse wohnt der Pflegebedürftige ?',
    type: 'text',
    required: true,
    answers: '',
  },
  {
    questionKey: 'houseNumber',
    question: 'Und wie ist die Hausnummer ?',
    type: 'text',
    required: true,
    answers: '',
  },
  {
    questionKey: 'zipCode',
    question: 'Können Sie mir bitte noch die Postleitzahl des Pflegebedürftigen nennen ?',
    type: 'number',
    required: true,
    answers: '',
  },
  {
    questionKey: 'city',
    question: 'Und den Ort.',
    type: 'text',
    required: true,
    answers: '',
  },
  {
    questionKey: 'phoneNumber',
    question: 'Für Rückfragen benötigen wir eine Telefonnummer.',
    type: 'phoneNumber',
    required: false,
    answers: '',
  },
  {
    questionKey: 'insurance',
    question:
      'Bei welcher Krankenversicherung ist der Pflegebedürftige ? Bitte wählen Sie aus der Liste aus. Keine Eile, ich trinke solange meinen Espresso.',
    type: 'option',
    required: true,
    answers: '',
  },
  {
    questionKey: 'attachmentForInsuranceCard',
    question:
      'Laden Sie hier bitte einen Nachweis über Ihren Versichertenstatus hoch. Das kann z.B. ein Bild Ihrer Krankenversichertekarte sein.',
    type: 'file',
    required: false,
    answers: '',
    fileName: '',
  },
  {
    questionKey: 'certificate',
    question:
      'Bitte laden Sie nun die Kopie des Pflegegradbescheids hoch, ohne sie können wir nicht weitermachen.',
    type: 'file',
    required: false,
    answers: '',
    fileName: '',
  },
  {
    questionKey: 'legalRepresentation',
    question: 'Steht der Pflegebedürftige unter gesetzlicher Betreuung ?',
    type: 'submit',
    required: true,
    answers: '',
  },
];

// Caregiver Questions (shown if legalRepresentation === 'Ja')
export const caregiverQuestions: Question[] = [
  {
    questionKey: 'lastName',
    question: 'Gut, kein Problem! Wie ist der Familienname des Betreuers ?',
    type: 'text',
    required: false,
    answers: '',
  },
  {
    questionKey: 'name',
    question: 'Und wie ist der Vorname?',
    type: 'text',
    required: false,
    answers: '',
  },
  {
    questionKey: 'address',
    question: 'Danke! In welcher Strasse wohnt oder arbeitet der Betreuer ?',
    type: 'text',
    required: false,
    answers: '',
  },
  {
    questionKey: 'houseNumber',
    question: 'Und bitte noch die Hausnummer.',
    type: 'text',
    required: false,
    answers: '',
  },
  {
    questionKey: 'zipCode',
    question: 'Können Sie mir bitte die Postleitzahl des Betreuers nennen ?',
    type: 'number',
    required: false,
    answers: '',
  },
  {
    questionKey: 'city',
    question: 'Und den Ort.',
    type: 'text',
    required: false,
    answers: '',
  },
  {
    questionKey: 'phoneNumber',
    question: 'Für Rückfragen geben Sie bitte eine Telefonnummer an.',
    type: 'phoneNumber',
    required: false,
    answers: '',
  },
  {
    questionKey: 'document',
    question:
      'Bitte laden Sie nun die Kopie der Betreuungsverfügung hoch, ohne sie können wir nicht weitermachen.',
    type: 'file',
    required: false,
    answers: '',
    fileName: '',
  },
];

// Terms and Conditions / Consent Questions
export const termsQuestions: Question[] = [
  {
    questionKey: 'iHere',
    question:
      'Hiermit bevollmächtige ich FLEXXI Care, in meinem Namen alle notwendigen Angelegenheiten im Zusammenhang mit der Beantragung und Abwicklung von Leistungen der Verhinderungspflege bei meiner Pflegekasse zu übernehmen, einschließlich der Einreichung von Unterlagen, der Kommunikation mit zuständigen Stellen sowie der Verwaltung der entsprechenden Vorgänge.',
    type: 'checkbox',
    required: true,
    answers: '',
  },
  {
    questionKey: 'ConsentToTheData',
    question: 'Ich stimme der Datenverarbeitung, vor allem nach § 67 III SGB X zu.',
    type: 'checkbox',
    required: true,
    answers: '',
  },
  {
    questionKey: 'iAgree',
    question:
      'Ich stimme zu, dass die Daten in Erfüllung der Aufgaben nach § 94 I Nr. 3 SGB XI verarbeitet werden. Sie sind erforderlich zur Prüfung des Anspruchs auf Verhinderungspflege nach § 39 SGB XI und erfordern die Mitwirkung nach § 60 SGB I. Mir ist bekannt, dass ohne Mitwirkung über den Anspruch nicht entschieden werden kann (§§ 33 I SGB XI, 60 I, 66 I SGB I). Mir ist bekannt, dass ich Allgemeine Informationen zur Datenverarbeitung und zu meinen Rechten von der Krankenkasse erhalten kann, wenn ich dies möchte. Die Angabe meiner Telefonnummer erfolgte freiwillig. Ich stimme zu, falls ich sie gegeben habe, dass ich bei Rückfragen telefonisch erreicht werden darf.',
    type: 'checkbox',
    required: true,
    answers: '',
  },
  {
    questionKey: 'iHave',
    question:
      'Ich habe alle Informationen freiwillig unter Zuhilfenahme der Dienste der FLEXXI Care Deutschland GmbH eingetragen und berechtige diese Firma, sie zum Zweck der Datenverarbeitung zu verwenden, insbesondere Ausdrucke für mich zu erstellen. Ich stelle FLEXXI Care von jeder Haftung, auch für fehlerhafte Übermittlung, frei. Ich habe vor Absendung die Verpflichtung, alle Unterlagen zu kontrollieren.',
    type: 'checkbox',
    required: true,
    answers: '',
  },
  {
    questionKey: 'signature',
    question: 'Bitte unterschreiben',
    type: 'signature',
    required: true,
    answers: '',
    fileName: '',
  },
];

// Robot Messages
export const robotMessages = {
  startChallenge:
    'Ich nehme dich Schritt für Schritt mit durch deinen Antrag. Ich bin an deiner Seite – egal, bei welcher der 149 Krankenkassen.',
  challengeSteps:
    'Hallo, mein Name ist FLEXX-i und ich freue mich, Ihnen zu helfen! Lassen Sie uns mit der Erstellung Ihres Antrags auf die Sorgen Los Karte. Beantworten Sie mir bitte folgende Fragen:',
  summary: 'Schicken Sie den Antrag ab, sobald Sie alle Angaben überprüft haben',
  thankYou:
    'Ihr Antrag wurde erfolgreich übermittelt! Wir prüfen Ihren Antrag in den nächsten 2-3 Werktagen und melden uns per E-Mail bei Ihnen.',
};

// Info Banner Text
export const infoBannerText =
  'Um die FLEXXI Sorgen Los Karte zu erhalten, benötigt die pflegebedürftige Person mindestens Pflegegrad 2 oder höher. Liegt kein Pflegegrad oder Pflegegrad 1 vor, kann die Sorgen Los Karte leider nicht beantragt werden.';
